import { z } from 'zod'
import React, { useState } from 'react'

const Newsletter = () => {
  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)

  const { dictionary } = window.newsletterData

  const schema = z.object({
    email: z
      .string()
      .min(1, dictionary.emailRequiredText)
      .email(dictionary.emailInvalidText),
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    const result = schema.safeParse({ email })
    if (!result.success) {
      setError(result.error.errors[0].message)
    } else {
      setError(null)
      // Handle successful submission
    }
  }

  return (
    <div className="s-footer__newsletter">
      <div className="s-footer__newsletter__title">
        {dictionary.newsletterTitle}
      </div>
      <div className="s-footer__newsletter__form">
        <form onSubmit={handleSubmit}>
          <div className="s-footer__newsletter__form__input">
            <input
              type="email"
              className="form-input-text"
              placeholder={dictionary.newsletterPlaceholder}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {error && (
              <span className="field-validation-error error">{error}</span>
            )}
          </div>

          <button type="submit" title="" className="btn btn-outline-white">
            {dictionary.newsletterBtnLabel}
          </button>
        </form>
      </div>
    </div>
  )
}

export default Newsletter
